export default "__VITE_ASSET__DSYG0YjQ__"